module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_Pxi_1",
      "src": "Images/Art_Pix_1.jpg"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "#/Text/contents#ah1",
      "id": "xah1"
    }
  }, [_vm._v("PREFACE")]), _vm._v(" "), _c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_Pxi_2",
      "src": "Images/Art_Pix_2.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('span', {
    staticClass: "dropcap"
  }, [_c('strong', [_vm._v("“T")])]), _vm._v("he only thing new in the world,” Harry S. Truman said, “is the history you don’t know.” Arctic historian Russell Potter has stated that “history can only live if one recovers its strangeness, its singularity, even its shock.” These two statements encapsulate much of what this book is all about. Its purpose is to inform, captivate, and surprise through stories that reveal and recover people, events, and developments that have been lost to history.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("What is amazing is that all of the stories you are about to read are not only compelling and true, but also the furthest thing from trivia. They are important stories—tales from throughout history (even prehistory) and from throughout the world—of unknown or little-known personalities, achievements, ingenuity, heroics, blunders, and outright disasters that changed the world and still resonate today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Here you will find the story of a man who is likely the most famous person you’ve never heard of, a man who during his all-too-brief lifetime became America’s greatest hero, a man whose death elicited the greatest outpouring of grief the nation had ever witnessed, and a man whose extraordinary adventures in the Arctic signaled the beginning of the exploration of that region and led directly to historic discoveries. Here you also will encounter the forgotten story of a much earlier explorer, the man who accomplished nothing less than completing the world’s first great voyage of discovery. And here as well you will meet the ninth-century black slave who not only revolutionized the world of music, but who also transformed cuisine, fashion, and manners in ways that remain with us today.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Surprise is a key ingredient of this book, and you should be prepared to have several of your long-held historical notions challenged—perhaps even disproved. Were the Wright brothers the first to achieve manned, powered flight? Did Paul Revere make the most important gallop during the American Revolution? Was the "), _c('em', [_vm._v("Titanic")]), _vm._v(" tragedy the greatest of all peacetime maritime disasters? Indeed, was the Chicago Fire of 1871 the "), _c('a', {
    attrs: {
      "id": "page_x"
    }
  }), _vm._v("greatest conflagration of its time or even of the very day on which it took place? Not according to what you’ll find within these pages.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("There are other astounding but true stories here as well, including the largely unknown saga of one of the most unique rescues in world history; the story of the building of America’s first subway, totally in secret; the story of the sophisticated city of some thirty thousand people that flourished in the heart of what is now the United States some 350 years before Columbus; and the saga of one of World War II’s greatest military disasters, purposely kept hidden for more than thirty years by the government.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("They are all remarkable stories, but even more extraordinary perhaps is that they have, for so long, been either lost or neglected. It is time for them to take their place in history.")]), _vm._v(" "), _c('p', {
    staticClass: "img"
  }, [_c('img', {
    staticStyle: {
      "max-width": "100%"
    },
    attrs: {
      "alt": "Art_Px_1",
      "src": "Images/Art_P2_1.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-d3faced8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/preface.vue
// module id = 78
// module chunks = 0